export const UsersImgSrc = "/cdn/users";



// WEBPACK FOOTER //
// ./src/inar2/constants.ts